import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-center justify-space-between" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "text-h4" }, "Cправочник категорий граждан")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Категория граждан"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Шифр категории"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Коэффициент")
  ])
], -1)
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = { class: "d-flex align-center justify-center" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "3",
    class: "text-center",
    style: {"border-top":"0"}
  }, "Нет данных")
], -1)
const _hoisted_7 = [
  _hoisted_6
]

import { Ref, computed, ref } from 'vue'
import {
  AppAuthService,
  CitizenCategoriesCoefficients,
  CitizenCategoriesCoefficientsService,
  CitizenCategory,
  CitizenCategoryCoefficient,
  citizenCategoryName,
  citizenCategoryShorthand,
  Permissions,
} from '@prodcard/core'
import { createCtx, handleError } from '../../../../helpers'
import { VFieldEditable } from '../../../../components'
import { useAuthPermissions } from '../../../../mixins'


export default /*#__PURE__*/_defineComponent({
  __name: 'CitizenCategoriesCoefficientsListPage',
  props: {
    citizenCategoriesCoefficientsService: {},
    authService: {}
  },
  setup(__props: any) {

const props = __props;


const { hasPermissions } = useAuthPermissions(props.authService)
const hasManage = computed(() => hasPermissions(Permissions.CITIZEN_CATEGORIES_COEFFICIENTS_MANAGE))

const citizenCategoriesCoefficients: Ref<CitizenCategoriesCoefficients | undefined> = ref(undefined)
const loading = ref(false)

handleError(async () => {
  citizenCategoriesCoefficients.value = await props.citizenCategoriesCoefficientsService.get(createCtx())
}, loading)

const updateCoefficientCitizenCategory = (
  citizenCategory: CitizenCategory,
  coefficientCitizenCategory: CitizenCategoryCoefficient,
) => {
  handleError(async () => {
    await props.citizenCategoriesCoefficientsService.updateByCitizenCategory(
      createCtx(),
      citizenCategory,
      coefficientCitizenCategory,
    )
    const response = await props.citizenCategoriesCoefficientsService.get(createCtx())
    if (citizenCategoriesCoefficients.value)
      citizenCategoriesCoefficients.value[citizenCategory] = response[citizenCategory]
  }, loading)
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createBlock(_component_v_sheet, null, {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_v_card, {
        loading: loading.value,
        disabled: loading.value,
        class: "mt-8"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_table, { hover: "" }, {
            default: _withCtx(() => [
              _hoisted_2,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(citizenCategoriesCoefficients.value, (coefficientCitizenCategory, citizenCategory) => {
                  return (_openBlock(), _createElementBlock("tr", { key: coefficientCitizenCategory }, [
                    _createElementVNode("td", null, _toDisplayString(_unref(citizenCategoryName)(citizenCategory)), 1),
                    _createElementVNode("td", _hoisted_3, _toDisplayString(_unref(citizenCategoryShorthand)(citizenCategory)), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("p", null, _toDisplayString(coefficientCitizenCategory), 1),
                        (hasManage.value)
                          ? (_openBlock(), _createBlock(_unref(VFieldEditable), {
                              "model-value": coefficientCitizenCategory,
                              key: coefficientCitizenCategory,
                              rules: [v => v >= 0 || 'Коэффициент не может быть меньше 0'],
                              type: "number",
                              "clear-after-close": "",
                              onUpdate: ($event: any) => (updateCoefficientCitizenCategory(citizenCategory, Number($event)))
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createVNode(_component_v_btn, _mergeProps({
                                  class: "ml-2",
                                  variant: "text",
                                  color: "primary",
                                  size: "small",
                                  density: "comfortable",
                                  icon: "mdi-pencil"
                                }, props), null, 16)
                              ]),
                              _: 2
                            }, 1032, ["model-value", "rules", "onUpdate"]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                }), 128))
              ]),
              (!citizenCategoriesCoefficients.value && !loading.value)
                ? (_openBlock(), _createElementBlock("tfoot", _hoisted_5, _hoisted_7))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["loading", "disabled"])
    ]),
    _: 1
  }))
}
}

})